import { apiClient } from '../services/api';
import { Deliverable } from '../types/work';

/**
 * 산출물. **2026-10-07 부터 실제 DB 를 본다** — 목데이터(work.json)는 지웠다.
 * 화면 모양(`order` · `archiveDocId`)을 바꾸지 않으려고 여기서 BE 모양(`sortOrder` · `documentId`)을 옮긴다.
 */
export const USE_MOCK = false;

export interface WorkDocument { id: number; title: string; category: string; docDate: string | null }

export interface WorkData {
  deliverables: Deliverable[];
  /** 이 프로젝트에 묶인 아카이브 문서 — 산출물에 이을 때 고른다 */
  documents: WorkDocument[];
}

/* eslint-disable @typescript-eslint/no-explicit-any */
const toWork = (r: any): WorkData => ({
  deliverables: (r.deliverables ?? []).map((d: any) => ({ id: d.id, projectId: d.projectId, order: d.sortOrder, name: d.name, dueDate: d.dueDate, submittedOn: d.submittedOn, archiveDocId: d.documentId, documentTitle: d.documentTitle })),
  documents: r.documents ?? [],
});
/* eslint-enable @typescript-eslint/no-explicit-any */

export const workApi = {
  async get(projectId: number): Promise<WorkData> {
    return toWork(await apiClient.get(`/projects/${projectId}/work`));
  },

  /* ── 산출물 ───────────────────────────────────────────── */

  /** 수주한 프로젝트에 슬롯이 없으면 기본 넷을 깐다 */
  async ensureDeliverables(projectId: number): Promise<WorkData> {
    return toWork(await apiClient.post(`/projects/${projectId}/work/deliverables/ensure`));
  },

  async addDeliverable(projectId: number, name: string, dueDate: string | null): Promise<WorkData> {
    return toWork(await apiClient.post(`/projects/${projectId}/work/deliverables`, { name, dueDate: dueDate || undefined }));
  },

  async setSubmitted(id: number, submitted: boolean): Promise<WorkData> {
    return toWork(await apiClient.patch(`/work/deliverables/${id}`, { submitted }));
  },

  /** 아카이브 문서를 잇는다. null 이면 푼다. 이 프로젝트에 묶인 문서만 된다 */
  async linkDocument(id: number, documentId: number | null): Promise<WorkData> {
    return toWork(await apiClient.patch(`/work/deliverables/${id}`, { documentId }));
  },

  async removeDeliverable(id: number): Promise<WorkData> {
    return toWork(await apiClient.delete(`/work/deliverables/${id}`));
  },

  /** 산출물 파일 올리기 — 드라이브 사업 폴더 「04.산출물」 · 아카이브 등록 · 이 슬롯에 잇고 제출 표시 */
  async uploadDeliverable(id: number, file: File): Promise<WorkData> {
    const form = new FormData();
    form.append('file', file);
    return toWork(await apiClient.postForm(`/work/deliverables/${id}/upload`, form));
  },
};

/** 프로젝트 파일 올리기 — 드라이브 사업 폴더(종류별 단계 폴더)에 저장하고 아카이브에 바로 등록 */
export async function uploadProjectFile(projectId: number, kind: '공고' | '제안서' | '계약' | '산출물' | '정산' | '견적' | '제출서류' | '작업자료', file: File): Promise<{ id: number; fileName: string }> {
  const form = new FormData();
  form.append('file', file);
  return apiClient.postForm(`/projects/${projectId}/files?kind=${encodeURIComponent(kind)}`, form);
}
